import './scss/bootstrap.scss';
import './scss/fontawesome.scss';
import './scss/spinao.scss';

import * as Lightgallery from './js/Spinao/Lightgallery';
import * as Carousel from "./js/bootstrap/carousel";
import * as Dropdown from "./js/bootstrap/dropdown";
import * as Collapse from "./js/bootstrap/collapse";
import BSCustomFileInput from './js/bootstrap/CustomFileUpload/index';
import * as StickyTopMenu from './js/Spinao/StickyTopMenu';
import * as UnifyHeight from './js/Spinao/UnifyHeight';
import * as BackToTop from './js/Spinao/BackToTop';
import * as EUCookie from './js/Spinao/EUCookie';
import * as GoogleMaps from './js/Spinao/GoogleMaps';
import './js/Spinao/GoogleReCaptcha';
import * as Offside from './js/offside';
import * as NetteAjaxForm from './js/Spinao/NetteAjaxForm';
import * as InfinityScroller from './js/Spinao/InfinityScroller';
import "./js/Spinao/CookieConsent";

document.addEventListener("DOMContentLoaded", function() {
    Offside.initialize('navbarCollapse', {
        buttonsSelector: '.js-offcanvas-trigger'
    });

    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    StickyTopMenu.initialize();

    UnifyHeight.applyTo('.js-unify-height');

    BackToTop.applyTo('backtotop_js');

    EUCookie.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');

    BSCustomFileInput.init();

    InfinityScroller.initialize();

    GoogleMaps.initialize();
});
